export const isValidURL = (callbackUrl = '') => {
  try {
    new URL(callbackUrl);
    return true;
  } catch (_) {
    return false;
  }
};
